import { useAppSelector } from '@/Application/Hooks/Redux';
import type { AccordionIndex } from '@/modules/perseo-billing/components/accordion/interfaces';
import { useAccordion } from '@/modules/perseo-billing/components/accordion/use-accordion';
import { useEnableAccordion } from '@/modules/perseo-billing/components/accordion/use-enable-accordion';
import type { ISavedCardResponse } from '@/modules/perseo-billing/interfaces';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';

import { AccordionTemplate } from '../accordion-template.component';

import { SavedCardBody, SavedCardHeader } from '.';

type TSavedCardProps = {
  savedCard: ISavedCardResponse;
  index: number;
  accordionIndex: number;
};

export const SavedCard = (props: TSavedCardProps) => {
  const { activeAccordion } = useAppSelector((state) => state.billing);
  const isMobile = useMediaQuery('lg');

  const { savedCard, index, accordionIndex } = props;

  const { getActiveItem } = useAccordion();
  const { getPaymentMethodEnabled } = useEnableAccordion();

  const accordionIndexes: AccordionIndex = {
    accordionIndex: accordionIndex ?? null,
    itemIndex: index ?? null
  };

  const isDefaultSavedCardOpen = !activeAccordion && index === 0 && !isMobile;

  const isActive = getActiveItem(accordionIndexes) || isDefaultSavedCardOpen;

  const isEnabled = !!savedCard && getPaymentMethodEnabled(savedCard.methodId);

  return (
    <AccordionTemplate
      isEnabled={isEnabled}
      header={
        <SavedCardHeader
          savedCard={savedCard}
          isActive={isActive}
          isEnabled={isEnabled}
          accordionIndexes={accordionIndexes}
        />
      }
      body={<SavedCardBody savedCard={savedCard} isActive={isActive} />}
      isActive={isActive}
    />
  );
};
